<template>
    <div :class="col + ' component-kira-select'">
        <div class="form-group mb-3">
            <label :for="id">
                <span class="text-truncate">
                    {{title}}
                </span>
                <i v-if="required == 'true'" class="fas fa-shield-alt"></i>
            </label>
            <div class="container">
                <v-select
                    :multiple="multiple"
                    label="text"
                    index="id"
                    :reduce="e => e.id"
                    :options="data"
                    v-model="selected"
                    :required="required"
                    @input="onChangeSelect"
                />
                <template v-if="Array.isArray(selected)">
                    <input v-for="(e, i) in selected" :key="i" :value="selected[i]" :name="`${name || 'select'}[${i}]`" :id="`${id || 'select'}-${i}`" type="text" hidden >
                </template>
                <template v-else>
                    <input :value="selected" :name="`${name || 'select'}`" :id="`${id || 'select'}`" type="text" hidden >
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import Axios from 'axios';

export default {
    props: [
        'id',
        'selectedValues',
        'title',
        'name',
        'reduce',
        'label',
        'multiple',
        'required',
        'options',
        'get'
    ],
    data() { return {
        col: 'col-xs-12 col-md-6 col-lg-4',
        selected: null,
        data:[]
    }},
    methods:{
        onChangeSelect () {
            console.log(this.selected)
            this.$emit('input', this.selected);
        },
        getData () {
            Axios.get(this.get).then(res => {
                this.data = res.data;
                this.getSelectedValues()
            });
        },
        getSelectedValues(){
            if (this.selectedValues && Array.isArray(this.data)){
                const values = Array.isArray(this.selectedValues) ? this.selectedValues.map( e => parseInt(e)) : [parseInt(this.selectedValues)]
                const selected = this.data.filter(e => values.includes(e.id) )
                this.selected = this.multiple ? selected : selected[0] || null
            }
        }
    },
    mounted() {
        if(this.get) {
                this.getData()
        } else {
            this.data = this.options
            this.getSelectedValues()
        }
    },
    watch:{
        get (val) {
            this.getData()
        }
    }
}
</script>
